import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortingVatDetailsPipe } from './sorting-vat-details.pipe';



@NgModule({
  declarations: [
    SortingVatDetailsPipe
  ],
  exports: [
    SortingVatDetailsPipe
  ],
  imports: [
    CommonModule
  ]
})
export class SortingVatDetailPipeModule { }
